// mui imports
import { Box, styled } from '@mui/material';

// custom components
import { SideCard } from 'components';

// utils
import { useNavigationRoutes } from 'utils/sideBarRoutes';
// import { navigationRoutes } from 'utils/sideBarRoutes';
// import {adminRoutes} from 'util/sideBarRoutes'

const BoxCont = styled(Box)(({ theme }) => {
  const { functions } = theme;
  // const { borderRadius } = borders;
  const { pxToRem } = functions;
  // console.log(navigationRoutes);
  return {
    padding: pxToRem(10),
    borderRadius: '2rem'
  };
});

const SideBar = () => {
  const { routes } = useNavigationRoutes();
  return (
    <BoxCont>
      <SideCard cardHead={{ title: 'Navigation' }} cardBody={{ items: routes }} />
    </BoxCont>
  );
};

export default SideBar;
